export default "__VITE_ASSET__232acf98__"